module.exports = __webpack_public_path__ + "img/11.22cc3e08.jpg";